export const SignatureCanvasResourcesBS: SignatureCanvasResourcesBSInterface = {
  clear: "Obrisi potpis",
  save: "Spasi potpis",
};

export interface SignatureCanvasResourcesBSInterface {
  clear: string;
  save: string;
}
